import React, { useEffect, useState } from 'react';
import styles from './ImageQuickViewModel.module.css';
import { AiOutlineCloseCircle } from 'react-icons/ai';
import api from '../../api/api';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../loader/Loader';
import { Modal } from 'react-bootstrap';
import { setProductSizes } from '../../model/reducer/productSizesReducer';
import ReactImageMagnify from 'react-image-magnify';



const ImageQuickViewModal = (props) => {
    const setting = useSelector(state => state.setting);
    const dispatch = useDispatch();
    const city = useSelector(state => state.city);
    const sizes = useSelector(state => state.productSizes);
    const [mainimage, setmainimage] = useState("");
    const [product, setproduct] = useState({});
    const [productSizes, setproductSizes] = useState(null);
    const [variant_index, setVariantIndex] = useState(null);

    useEffect(() => {
        if (Object.keys(props.selectedProduct).length > 0 && city.city !== null && Object.keys(product)?.length === 0 && props.showModal === true) {
            fetchProduct(props.selectedProduct.id);
        }
        else if (props.showModal === true) {
            fetchProductVariant(props.selectedProduct.id);
        }
    }, [props.selectedProduct, city]);



    const fetchProduct = async (product_id) => {
        await api.getProductbyId(city.city.latitude, city.city.longitude, product_id, localStorage.getItem('jwt_token'))
            .then(response => response.json())
            .then(result => {
                if (result.status === 1) {
                    setproduct(result.data);
                    setVariantIndex(result.data.variants?.length > 0 && result.data.variants[0]?.id);
                    setmainimage(result.data.image_url);
                }
            })
            .catch(error => console.log(error));
    };

    const fetchProductVariant = async (product_id) => {
        await api.getProductbyId(city.city.latitude, city.city.longitude, product_id, localStorage.getItem('jwt_token'))
            .then(response => response.json())
            .then(result => {
                if (result.status === 1) {
                    setproduct(result.data);
                    setVariantIndex(result.data.variants?.length > 0 && result.data.variants[0]?.id);
                    setmainimage(result.data.image_url);
                }
            })
            .catch(error => console.log(error));
    };



    useEffect(() => {
        if (sizes.sizes === null || sizes.status === 'loading') {
            if (city.city !== null) {
                api.getProductbyFilter(city.city.latitude, city.city.longitude, localStorage.getItem('jwt_token'))
                    .then(response => response.json())
                    .then(result => {
                        if (result.status === 1) {
                            setproductSizes(result.sizes);
                            dispatch(setProductSizes({ data: result.sizes }));
                        }
                    });
            }
        }
        else {
            setproductSizes(sizes.sizes);
        }
    }, [city, sizes]);


    const placeHolderImage = (e) => {
        e.target.src = setting.setting?.web_logo;
    };

    return (
        <Modal
            size='xl'
            centered
            show={props.showModal}
            onHide={() => props.setShowModal(false)}
            backdrop={"static"}>
            <div className={styles.productdetailsview}>
                <Modal.Body className='modal-body'>
                    <div className="d-flex flex-row justify-content-end header">
                        <button type="button" aria-label="Close" onClick={() => {
                            props.setselectedProduct({});
                            setproduct({});
                            setVariantIndex(0);
                            props.setShowModal(false);
                        }} className="bg-white"><AiOutlineCloseCircle size={30} /></button>
                    </div>
                    {Object.keys(product).length === 0 || productSizes === null ? (< Loader />)
                        : (
                            <div className={`${styles.topwrapper} top-wrapper`}>
                                <div className={`row ${styles.bodywrapper}`}>
                                    <div className={`${styles.mainimage} col`}>
                                        <div style={{ cursor: "pointer" }}>
                                            <ReactImageMagnify
                                                {...{
                                                    smallImage: {
                                                        alt: 'Product Image',
                                                        isFluidWidth: true,
                                                        src: mainimage,
                                                    },
                                                    largeImage: {
                                                        src: mainimage,
                                                        width: 1500,
                                                        height: 1500,
                                                    },
                                                    enlargedImageContainerStyle: {
                                                        background: 'none',
                                                        zIndex: 1000,
                                                    },
                                                    isHintEnabled: true,
                                                    enlargedImagePosition: "over",
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className={`${styles.detailwrapper} detail-wrapper`}>
                                            <div className={`${styles.topsection} top-section`}>
                                                <a href={`/product/${product.slug}`} className={styles.product_name}>
                                                    {product.name}
                                                </a>
                                            </div>
                                            <div className={styles.bottomsection}>
                                                <label className={styles.sku}>{product.sku}</label>
                                                <div className={` ${styles.subimagescontainer} sub-images-container row`}>
                                                    <>
                                                        {product.images.map((image, index) => (
                                                            <div key={index} className={`${styles.subimage} ${mainimage === image ? styles.active : ''}`.trim()}>
                                                                <img onError={placeHolderImage} src={image} className='col-12 ' alt="product" onClick={() => {
                                                                    setmainimage(image);
                                                                }}></img>
                                                            </div>
                                                        ))}
                                                    </>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    }
                </Modal.Body>
            </div>
        </Modal>
    );

};

export default ImageQuickViewModal;
